export default __webpack_public_path__ + "static/media/line-chart.898c73b1.png";